export const getEntityModelId = (): string =>
  import.meta.env.VITE_ENTITY_MODEL_ID ?? "";

export const getEntityModelType = (): string =>
  import.meta.env.VITE_ENTITY_MODEL_TYPE ?? "";

export const getEntityModelParam = () => ({
  entity_model_id: getEntityModelId(),
  entity_model_type: getEntityModelType(),
});
